import { OperationAlertDeliveryGroup } from "../../../types/alert/operation-alert-delivery-group";
import { LocalStorageKey } from "../../../types/local-storage/local-storage-key";
import { AlertState } from "../../type/alert-state";
import { setIndexedDBItem } from "../../../utils/indexed-db/indexed-db-util";

interface Action {
  type: string;
  payload: {
    alerts: OperationAlertDeliveryGroup[];
  };
}

export const setOldNotStartedAlertDispatch = (
  state: AlertState,
  action: Action
) => {
  const { alerts } = action.payload;

  state.oldAlerts.schedulesNotStarted = alerts;
  setIndexedDBItem(LocalStorageKey.SchedulesNotStarted, JSON.stringify(alerts));
};
